__turbopack_context__.v({
  "modalContainer": "sharePreview-module__rS1baG__modalContainer",
  "modalWrap": "sharePreview-module__rS1baG__modalWrap",
  "previewChat": "sharePreview-module__rS1baG__previewChat",
  "previewRoot": "sharePreview-module__rS1baG__previewRoot",
});
